import React, {useState} from "react";
import PropTypes from "prop-types";

import PhotoDropzone from "@/components/form/PhotoDropzone.jsx";
import {useModal} from "@/hooks/useModal.jsx";
import ImageEditor from "@/components/dialogs/ImageEditor.jsx";
import {convertToJpeg} from "@/utils/convertToJpeg.jsx";
import {toBase64} from "@/utils/toBase64.jsx";
import axios from "axios";
import ErrorNotification from "@/components/dialogs/ErrorNotification.jsx";
import {UPLOAD_PROFILE_PHOTO} from "@/constants/routes/index.jsx";

export default function ProfilePhotoUpload({image, uploadText, borderRadius = 10, emptyIcon, error = null, imageEditor = false, onChange}) {
    const {openModal, closeModal} = useModal();

    const [loading, setLoading] = useState(false);

    const upload = async (file) => {
        try {
            const response = await axios.post(UPLOAD_PROFILE_PHOTO, {file: file}, {
                withCredentials: true,
                validateStatus: function (status) {
                    return status < 500;
                },
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
            });

            switch (response.status) {
                case 200:
                    return response.data;
                    break;
                case 422:
                    if (response.data?.errors?.file) {
                        openModal(
                            <ErrorNotification>
                                {response.data?.errors?.file[0]}
                            </ErrorNotification>
                        );
                    }
                    break;
                default:
                    openModal(
                        <ErrorNotification>
                            {response?.data?.errorNotification}
                        </ErrorNotification>
                    );
            }
        } catch (error) {
            if(error?.message?.length > 0) {
                openModal(
                    <ErrorNotification>
                        {error.message}
                    </ErrorNotification>
                );
            } else {
                openModal(
                    <ErrorNotification/>
                );
            }
        }
    };

    const handleChange = (file) => {
        setLoading(true);

        if (!file) {
            onChange(file);
            setLoading(false);
            return;
        }

        convertToJpeg(file).then((photoJpegData) => {
            toBase64(photoJpegData).then((photo) => {
                upload(photo)
                    .then((logoData) => {
                        console.log('logoData', logoData);
                        onChange(logoData)
                        setLoading(false);
                });
            });
        });
    }

    return (
        <>
            <PhotoDropzone
                loading={loading}
                image={image}
                uploadText={uploadText}
                borderRadius={borderRadius}
                emptyIcon={emptyIcon}
                error={error}
                onDrop={(files) => {
                    if(imageEditor){
                        return new Promise((resolve) => {
                            openModal(<ImageEditor image={files[0]}
                                                   borderRadius={borderRadius * 7}
                                                   onClose={() => {
                                                       closeModal();
                                                   }}
                                                   onSave={(file) => {
                                                       closeModal();
                                                       handleChange(file)
                                                   }}/>);
                            resolve();
                        })
                    } else {
                        handleChange(files[0])
                    }
                }}
                onRemove={() => {
                    handleChange(null);
                }}
            />
        </>
    );
}

ProfilePhotoUpload.propTypes = {
    onChange: PropTypes.func,
    imageEditor: PropTypes.bool,
};
